export default __webpack_public_path__ + "static/media/area-16.2f3061c0.jpg";